import angular from 'angular';

import { cartService } from './services/cartService';
import { RestaurantInfoFactory } from './services/restaurantInfoFactory';

import { FeesTotalsTableDirective } from './directives/feesTotalsDirective';

export const SummaryModule = angular
    .module('oo.common.summary', [])
    .factory('cartService', cartService)
    .factory('restaurantInfoFactory', RestaurantInfoFactory)
    .directive('feesTotalsTable', FeesTotalsTableDirective)
    .name;
